<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Articles'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Articles',
            actions: [
                {
                    icon: 'fas fa-map-pin',
                    method: 'togglePin',
                    where: {
                        isPinned: {
                            value: false
                        }
                    }
                },
                {
                    icon: 'fas fa-eraser',
                    method: 'togglePin',
                    where: {
                        isPinned: {
                            value: true
                        }
                    }
                }
            ]
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'status',
                    type: 'enum',
                    enumOptions: ['draft', 'published'],
                    width: '150px'
                },
                {
                    value: 'isPinned',
                    text: 'Pinned',
                    width: '100px',
                    type: 'boolean',
                    filter: v => (v ? 'Yes' : '-')
                },
                {
                    value: 'isFeatured',
                    text: 'Feed',
                    width: '100px',
                    type: 'boolean',
                    filter: v => (v ? 'Yes' : '-')
                },
                {
                    value: 'category.name',
                    width: '150px'
                },
                {
                    value: 'tags',
                    width: '150px',
                    sortable: false,
                    filterFieldName: 'tags.name',
                    filter: 'joinTable'
                },
                {
                    value: 'campuses',
                    text: 'Campus',
                    width: '200px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'articles/index',
            deleteItem: 'articles/destroy',
            pinArticle: 'articles/pin',
            unpinArticle: 'articles/unpin'
        }),

        onRowClick({ id }) {
            this.$router.push(`/articles/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/articles/add');
        },

        async togglePin(id, index) {
            const { isPinned } = this.items[index];

            const type = isPinned ? 'unpin' : 'pin';

            try {
                await this[`${type}Article`](id);

                this.items.splice(index, 1, {
                    ...this.items[index],
                    isPinned: type === 'pin'
                });

                this.$toaster(`Article has been ${type}ned.`);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
